var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoSinFondo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "167.000000pt",
    height: "165.000000pt",
    viewBox: "0 0 167.000000 165.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,165.000000) scale(0.100000,-0.100000)",
    fill: "#3691B3",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205 1611 c-79 -20 -134 -72 -154 -146 -15 -55 -15 -935 0 -990 15 -55 52 -101 102 -127 38 -20 60 -23 215 -26 l172 -4 0 -125 c0 -133 8 -163 42 -163 13 0 104 62 212 144 l191 145 245 3 c231 3 247 4 287 25 50 27 87 73 102 128 15 55 15 935 0 990 -15 55 -52 101 -102 128 l-42 22 -620 2 c-341 1 -633 -2 -650 -6z m1273 -153 c17 -17 17 -959 0 -976 -9 -9 -77 -12 -243 -12 -126 0 -244 -4 -261 -9 -17 -5 -86 -50 -153 -100 -67 -50 -126 -91 -132 -91 -5 0 -9 15 -9 33 0 49 -39 118 -80 142 -31 18 -56 20 -215 23 -104 2 -185 8 -192 14 -18 15 -19 958 -1 976 17 17 1269 17 1286 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 1007 c-13 -7 -31 -24 -39 -38 -13 -24 -13 -29 3 -53 9 -15 29 -31 44 -37 15 -6 118 -9 255 -7 l229 3 24 28 c30 35 30 49 0 84 l-24 28 -234 3 c-174 2 -239 -1 -258 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090 1008 c-13 -7 -31 -25 -39 -39 -13 -24 -13 -29 3 -53 24 -38 59 -48 149 -44 72 3 81 6 103 31 30 35 30 49 0 84 -23 26 -30 28 -108 31 -54 2 -92 -2 -108 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 758 c-13 -7 -31 -25 -39 -39 -13 -24 -13 -29 3 -53 24 -38 59 -48 149 -44 72 3 81 6 103 31 30 35 30 49 0 84 -23 26 -30 28 -108 31 -54 2 -92 -2 -108 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790 757 c-13 -7 -31 -24 -39 -38 -13 -24 -13 -29 3 -53 9 -15 29 -31 44 -37 15 -6 118 -9 255 -7 l229 3 24 28 c30 35 30 49 0 84 l-24 28 -234 3 c-174 2 -239 -1 -258 -11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoSinFondo);
export default __webpack_public_path__ + "static/media/Icono-sin-fondo.00a532f36f8bfc85c2b4de075e8b6792.svg";
export { ForwardRef as ReactComponent };